/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetHarmfulFactorTestDto } from './GetHarmfulFactorTestDto';
import {
    GetHarmfulFactorTestDtoFromJSON,
    GetHarmfulFactorTestDtoFromJSONTyped,
    GetHarmfulFactorTestDtoToJSON,
} from './GetHarmfulFactorTestDto';
import type { GetHarmfulFactorSuppExamDictDto } from './GetHarmfulFactorSuppExamDictDto';
import {
    GetHarmfulFactorSuppExamDictDtoFromJSON,
    GetHarmfulFactorSuppExamDictDtoFromJSONTyped,
    GetHarmfulFactorSuppExamDictDtoToJSON,
} from './GetHarmfulFactorSuppExamDictDto';

/**
 * 
 * @export
 * @interface GetHarmfulFactorDto
 */
export interface GetHarmfulFactorDto {
    /**
     * 
     * @type {string}
     * @memberof GetHarmfulFactorDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetHarmfulFactorDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetHarmfulFactorDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetHarmfulFactorDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof GetHarmfulFactorDto
     */
    category?: GetHarmfulFactorDtoCategoryEnum;
    /**
     * 
     * @type {Array<GetHarmfulFactorSuppExamDictDto>}
     * @memberof GetHarmfulFactorDto
     */
    harmfulFactorSupports?: Array<GetHarmfulFactorSuppExamDictDto> | null;
    /**
     * 
     * @type {Array<GetHarmfulFactorTestDto>}
     * @memberof GetHarmfulFactorDto
     */
    harmfulFactorTests?: Array<GetHarmfulFactorTestDto> | null;
    /**
     * 
     * @type {number}
     * @memberof GetHarmfulFactorDto
     */
    yearsForJudgment?: number;
    /**
     * 
     * @type {number}
     * @memberof GetHarmfulFactorDto
     */
    systemNumber: number;
}


/**
 * @export
 */
export const GetHarmfulFactorDtoCategoryEnum = {
    Biological: 'Biological',
    Chemical: 'Chemical',
    Physical: 'Physical',
    Other: 'Other',
    Learn: 'Learn'
} as const;
export type GetHarmfulFactorDtoCategoryEnum = typeof GetHarmfulFactorDtoCategoryEnum[keyof typeof GetHarmfulFactorDtoCategoryEnum];


/**
 * Check if a given object implements the GetHarmfulFactorDto interface.
 */
export function instanceOfGetHarmfulFactorDto(value: object): value is GetHarmfulFactorDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('systemNumber' in value) || value['systemNumber'] === undefined) return false;
    return true;
}

export function GetHarmfulFactorDtoFromJSON(json: any): GetHarmfulFactorDto {
    return GetHarmfulFactorDtoFromJSONTyped(json, false);
}

export function GetHarmfulFactorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHarmfulFactorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'active': json['active'],
        'description': json['description'],
        'category': json['category'] == null ? undefined : json['category'],
        'harmfulFactorSupports': json['harmfulFactorSupports'] == null ? undefined : ((json['harmfulFactorSupports'] as Array<any>).map(GetHarmfulFactorSuppExamDictDtoFromJSON)),
        'harmfulFactorTests': json['harmfulFactorTests'] == null ? undefined : ((json['harmfulFactorTests'] as Array<any>).map(GetHarmfulFactorTestDtoFromJSON)),
        'yearsForJudgment': json['yearsForJudgment'] == null ? undefined : json['yearsForJudgment'],
        'systemNumber': json['systemNumber'],
    };
}

export function GetHarmfulFactorDtoToJSON(value?: GetHarmfulFactorDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'active': value['active'],
        'description': value['description'],
        'category': value['category'],
        'harmfulFactorSupports': value['harmfulFactorSupports'] == null ? undefined : ((value['harmfulFactorSupports'] as Array<any>).map(GetHarmfulFactorSuppExamDictDtoToJSON)),
        'harmfulFactorTests': value['harmfulFactorTests'] == null ? undefined : ((value['harmfulFactorTests'] as Array<any>).map(GetHarmfulFactorTestDtoToJSON)),
        'yearsForJudgment': value['yearsForJudgment'],
        'systemNumber': value['systemNumber'],
    };
}

